<template>
  <div class="terms-container">
    <!-- Header -->
    <div class="terms-header">
      <div class="terms-icon">
        <i class="fas fa-file-contract"></i>
      </div>
      <div class="terms-title-section">
        <h3 class="terms-title">Términos y Condiciones</h3>
        <p class="terms-subtitle">Pago Automático con Tarjeta de Crédito - Transbank</p>
      </div>
    </div>

    <!-- Badge de seguridad -->
    <div class="security-badge">
      <i class="fas fa-shield-alt"></i>
      <span>Procesado de forma segura mediante Transbank</span>
    </div>

    <!-- Contenido de términos -->
    <div class="terms-content">
      <!-- Simonetti -->
      <div v-if="customer == 'simonetti'">
        <div class="terms-section">
          <div class="section-header">
            <i class="fas fa-info-circle"></i>
            <h4>Introducción</h4>
          </div>
          <div class="section-body">
            <p>
              Las personas que suscriban contratos de promesa de compraventa (Cliente)
              por uno o más inmuebles con <strong>Simonetti</strong> (Simonetti Inmobiliaria S.A.,
              Simonetti Constructora SpA), podrán acceder a la modalidad de pago de
              parte o todo el precio de sus respectivos contratos, mediante el cargo
              automático que se haga en sus respectivas cuentas corrientes bancarias o
              tarjetas de crédito, utilizando la plataforma que para tales efectos
              mantenga vigente Transbank, quien en calidad de mandatario y mero tenedor,
              facilitará el proceso de pago correspondiente, a través de cuotas
              convenidas en los contratos de promesa de compraventa o compraventa
              respectivos.
            </p>
            <p>
              A tales efectos el Cliente otorgará un mandato específico a
              Transbank y/o cualquier otro documento que sea necesario y/o requerido por
              este último, y deberá aceptar los términos y condiciones contenidos que se
              indica a continuación.
            </p>
          </div>
        </div>

        <div class="terms-section">
          <div class="section-header">
            <i class="fas fa-cog"></i>
            <h4>Mecanismo de Pago</h4>
          </div>
          <div class="section-body">
            <p>
              Para acceder esta forma de pago, el Cliente deberá ingresar a <strong>Mi Cuenta</strong> en
              la página web de Simonetti (www.simonetti.cl), y elegir dentro de las
              opciones para materializar el pago de su respectivo contrato y de acuerdo
              a lo convenido en él, el número de cuotas, el monto de ellas y la fecha de
              pago/cargo.
            </p>
            <p>
              Para tales efectos, deberá seleccionar la opción "Pagos",
              accediendo a la interfaz de ésta, mediante la cual, dependiendo de la
              opción que escoja, podrá a su vez optar por el pago mediante:
            </p>
            <ul class="payment-options-list">
              <li><i class="fas fa-university"></i> <strong>PAC</strong> - Pago automático en cuenta corriente</li>
              <li><i class="fas fa-credit-card"></i> <strong>PAT</strong> - Pago automático en tarjeta de crédito</li>
            </ul>
            <p>
              Canalizándose a través de Webpay Oneclick de Transbank y/o
              mediante otra u otras que podrían estar disponibles para los mismos
              efectos, caso en el cual se conectará a ellas, aplicando asimismo los
              términos y condiciones particulares de la correspondiente Webpay.
            </p>
          </div>
        </div>

        <div class="terms-section">
          <div class="section-header">
            <i class="fas fa-exclamation-triangle"></i>
            <h4>Condiciones Importantes</h4>
          </div>
          <div class="section-body">
            <div class="highlight-box">
              <p>
                <i class="fas fa-check-circle"></i>
                Cualquiera sea la opción de pago que escoja el Cliente mediante la
                plataforma Mi Cuenta - Pagos, deberá ingresar, completar, otorgar y/o
                suscribir todos los antecedentes, mandatos y/o demás información que al
                efecto se requiera.
              </p>
            </div>
            <p>
              Cualquiera que sea la modalidad elegida por el Cliente, deberá respetar la
              periodicidad, número de cuotas, monto y fecha de pago/cargo que se
              convenga en el respectivo contrato de promesa de compraventa o de
              compraventa que Simonetti y el Cliente suscriban.
            </p>
            <p>
              Cualquier transacción que se efectúe mediante el sistema referido, será
              canalizada y administrada a través de los sistemas y páginas web que
              Transbank disponga para ello. La web de Simonetti, solo permitirá
              redireccionar a cada Cliente a los referidos sistemas y páginas web, por
              lo que Simonetti no tendrá acceso ni guardará los datos ingresados por el
              Cliente, cualquiera que estos sean y especialmente respecto de la cuenta
              y/o tarjeta registradas por el Cliente al configurar la opción de pago.
            </p>
            <div class="warning-box">
              <i class="fas fa-info-circle"></i>
              <p>
                Simonetti no tendrá responsabilidad alguna ni podrá imputársele cualquier
                problema de permeabilidad y/o fallas que puedan experimentar los sistemas
                y/o las páginas web de Transbank, mediante la cual se materialice el pago,
                y/o que en virtud de ello, pueda experimentar la cuenta y/o tarjeta
                registradas.
              </p>
            </div>
            <p>
              El Cliente solo podrá tener activa <strong>1 (una)</strong> cuenta o tarjeta por cada
              contrato que suscriba con Simonetti, por lo que si el Cliente deseara
              reemplazar la cuenta o tarjeta que hubiere registrado y reemplazarla por
              otra que estuviere vigente, podrá hacerlo directamente a través de la web
              de Simonetti. Cualquier cambio que se realice respecto de la modalidad de
              pago deberá acordarse previamente entre Simonetti y el Cliente.
            </p>
          </div>
        </div>

        <div class="terms-section authorization-section">
          <div class="section-header">
            <i class="fas fa-check-double"></i>
            <h4>Autorización de Pago Automático</h4>
          </div>
          <div class="section-body">
            <p>
              Con la aceptación de los presentes términos y condiciones, independiente
              de los mandatos que al efecto deban otorgarse, y/o de los términos y
              condiciones propios de Transbank disponga al efecto, el Cliente autoriza
              por esta aceptación, <strong>expresamente a Transbank</strong> para que ésta concurra al
              Banco que corresponda, y le solicite los fondos que corresponda, con cargo
              a la Cuenta Corriente y/o a la Tarjeta de Crédito designada para tal
              efecto, y que con dichos fondos proceda directamente al pago de las cuotas
              comprometidas a pagar a Simonetti, destinando al pago del precio del
              contrato de promesa de compraventa respectivo, calculado en base al valor
              de la UF del día de pago acordado y/o efectivo.
            </p>
            <p>
              El pago, para el caso de Pago Automático con cargo a la Cuenta Corriente,
              se materializará mediante la transferencia directa a Simonetti. 
              <strong>La presente autorización tiene vigencia indefinida.</strong>
            </p>
            <div class="highlight-box revocation-box">
              <p>
                <i class="fas fa-undo"></i>
                <strong>Revocación:</strong> El Cliente podrá revocar esta autorización, siempre que en forma previa
                haya acordado con Simonetti la nueva modalidad de pago, de lo que deberá
                darse cuenta de ello mediante la celebración de la respectiva modificación
                del contrato de promesa de compraventa que se hubiere firmado.
              </p>
            </div>
            <p>
              La presente autorización se entenderá otorgada, para todos los efectos legales, el
              mismo día en que, a través de la web de Simonetti, se proceda a configurar
              la opción de pago a través de la opción Transbank, entregándose,
              otorgándose y/o suscribiéndose todos los antecedentes, mandatos y/o demás
              información que al efecto ésta requiera.
            </p>
            <p>
              Todas las autorizaciones que se hubieren otorgado en forma indefinida, se
              entenderán <strong>renovadas mes a mes</strong>, en tanto no se revoque por escrito.
            </p>
          </div>
        </div>
      </div>

      <!-- Gespania -->
      <div v-else-if="customer == 'gespania'">
        <div class="terms-section">
          <div class="section-header">
            <i class="fas fa-info-circle"></i>
            <h4>Introducción</h4>
          </div>
          <div class="section-body">
            <p>
              Las personas que suscriban contratos de promesa de compraventa (Cliente)
              por uno o más inmuebles con el <strong>Grupo Gespania</strong> (Inmobiliaria El Rosal S.A.,
              Inmobiliaria Las Palmeras S.A., Inmobiliaria Altos del Mar SPA,
              Inmobiliaria Andalucía S.A., Inmobiliaria Lazo S.A., Inmobiliaria Salas
              S.A., Inmobiliaria La Fontana S.A.), podrán acceder a la modalidad de pago
              de parte o todo el precio de sus respectivos contratos, mediante el cargo
              automático que se haga en sus respectivas cuentas corrientes bancarias o
              tarjetas de crédito, utilizando la plataforma que para tales efectos
              mantenga vigente Transbank, quien en calidad de mandatario y mero tenedor,
              facilitará el proceso de pago correspondiente, a través de cuotas
              convenidas en los contratos de promesa de compraventa o compraventa
              respectivos.
            </p>
            <p>
              A tales efectos el Cliente otorgará un mandato específico a
              Transbank y/o cualquier otro documento que sea necesario y/o requerido por
              este último, y deberá aceptar los términos y condiciones contenidos que se
              indica a continuación.
            </p>
          </div>
        </div>

        <div class="terms-section">
          <div class="section-header">
            <i class="fas fa-cog"></i>
            <h4>Mecanismo de Pago</h4>
          </div>
          <div class="section-body">
            <p>
              Para acceder a esta forma de pago, el Cliente deberá ingresar a la página
              web de Gespania (www.gespania.cl), y elegir dentro de las opciones para
              materializar el pago de su respectivo contrato y de acuerdo a lo convenido
              en él, el número de cuotas, el monto de ellas y la fecha de pago/cargo.
            </p>
            <p>
              Para tales efectos, deberá seleccionar la opción "Pagos", accediendo a la
              interfaz de ésta, mediante la cual, dependiendo de la opción que escoja,
              podrá a su vez optar por el pago mediante:
            </p>
            <ul class="payment-options-list">
              <li><i class="fas fa-university"></i> <strong>PAC</strong> - Pago automático en cuenta corriente</li>
              <li><i class="fas fa-credit-card"></i> <strong>PAT</strong> - Pago automático en tarjeta de crédito</li>
            </ul>
            <p>
              Canalizándose a través de Webpay Oneclick de Transbank y/o mediante otra u otras que
              podrían estar disponibles para los mismos efectos, caso en el cual se
              conectará a ellas, aplicando asimismo los términos y condiciones
              particulares de la correspondiente Webpay.
            </p>
          </div>
        </div>

        <div class="terms-section">
          <div class="section-header">
            <i class="fas fa-exclamation-triangle"></i>
            <h4>Condiciones Importantes</h4>
          </div>
          <div class="section-body">
            <div class="highlight-box">
              <p>
                <i class="fas fa-check-circle"></i>
                Cualquiera sea la opción de pago que escoja el Cliente mediante la
                plataforma, deberá ingresar, completar, otorgar y/o suscribir todos los 
                antecedentes, mandatos y/o demás información que al efecto se requiera.
              </p>
            </div>
            <p>
              Cualquiera que sea la modalidad elegida por el Cliente, deberá respetar la 
              periodicidad, número de cuotas, monto y fecha de pago/cargo que se convenga 
              en el respectivo contrato de promesa de compraventa o de compraventa que 
              Gespania y el Cliente suscriban.
            </p>
            <p>
              Cualquier transacción que se efectúe mediante el sistema referido, será
              canalizada y administrada a través de los sistemas y páginas web que
              Transbank disponga para ello. La web de Gespania, solo permitirá
              redireccionar a cada Cliente a los referidos sistemas y páginas web, por
              lo que Gespania no tendrá acceso ni guardará los datos ingresados por el
              Cliente, cualquiera que estos sean y especialmente respecto de la cuenta
              y/o tarjeta registradas por el Cliente al configurar la opción de pago.
            </p>
            <div class="warning-box">
              <i class="fas fa-info-circle"></i>
              <p>
                Gespania no tendrá responsabilidad alguna ni podrá imputársele
                cualquier problema de permeabilidad y/o fallas que puedan experimentar los
                sistemas y/o las páginas web de Transbank, mediante la cual se materialice
                el pago, y/o que en virtud de ello, pueda experimentar la cuenta y/o
                tarjeta registradas.
              </p>
            </div>
            <p>
              El Cliente solo podrá tener activa <strong>1 (una)</strong> cuenta o tarjeta por cada
              contrato que suscriba con Gespania, por lo que si el Cliente deseara
              reemplazar la cuenta o tarjeta que hubiere registrado y reemplazarla por
              otra que estuviere vigente, podrá hacerlo directamente a través de la web
              de Gespania. Cualquier cambio que se realice respecto de la modalidad de
              pago deberá acordarse previamente entre Gespania y el Cliente.
            </p>
          </div>
        </div>

        <div class="terms-section authorization-section">
          <div class="section-header">
            <i class="fas fa-check-double"></i>
            <h4>Autorización de Pago Automático</h4>
          </div>
          <div class="section-body">
            <p>
              Con la aceptación de los presentes términos y condiciones, independiente
              de los mandatos que al efecto deban otorgarse, y/o de los términos y
              condiciones propios de Transbank disponga al efecto, el Cliente autoriza
              por esta aceptación, <strong>expresamente a Transbank</strong> para que ésta concurra al
              Banco que corresponda, y le solicite los fondos que corresponda, con cargo
              a la Cuenta Corriente y/o a la Tarjeta de Crédito designada para tal
              efecto, y que con dichos fondos proceda directamente al pago de las cuotas
              comprometidas a pagar a Gespania, destinando al pago del precio del
              contrato de promesa de compraventa respectivo, calculado en base al valor
              de la UF del día de pago acordado y/o efectivo.
            </p>
            <p>
              El pago, para el caso de Pago Automático con cargo a la Cuenta Corriente,
              se materializará mediante la transferencia directa a Gespania. 
              <strong>La presente autorización tiene vigencia indefinida.</strong>
            </p>
            <div class="highlight-box revocation-box">
              <p>
                <i class="fas fa-undo"></i>
                <strong>Revocación:</strong> El Cliente podrá revocar esta autorización, siempre que en forma previa
                haya acordado con Gespania la nueva modalidad de pago, de lo que deberá
                darse cuenta de ello mediante la celebración de la respectiva modificación
                del contrato de promesa de compraventa que se hubiere firmado.
              </p>
            </div>
            <p>
              La presente autorización se entenderá otorgada, para todos los efectos legales, el
              mismo día en que, a través de la web de Gespania, se proceda a configurar
              la opción de pago a través de la opción Transbank, entregándose,
              otorgándose y/o suscribiéndose todos los antecedentes, mandatos y/o demás
              información que al efecto ésta requiera.
            </p>
            <p>
              Todas las autorizaciones que se hubieren otorgado en forma indefinida, se
              entenderán <strong>renovadas mes a mes</strong>, en tanto no se revoque por escrito.
            </p>
          </div>
        </div>
      </div>

      <!-- Default / Otros clientes -->
      <div v-else>
        <div class="terms-section">
          <div class="section-header">
            <i class="fas fa-info-circle"></i>
            <h4>Introducción</h4>
          </div>
          <div class="section-body">
            <p>
              Las personas que suscriban contratos de promesa de compraventa (Cliente)
              por uno o más inmuebles con <strong>La Inmobiliaria</strong>, podrán
              acceder a la modalidad de pago de parte o todo el precio de sus
              respectivos contratos, mediante el cargo automático que se haga en sus
              respectivas cuentas corrientes bancarias o tarjetas de crédito, utilizando
              la plataforma que para tales efectos mantenga vigente Transbank, quien en
              calidad de mandatario y mero tenedor, facilitará el proceso de pago
              correspondiente, a través de cuotas convenidas en los contratos de promesa
              de compraventa o compraventa respectivos.
            </p>
            <p>
              A tales efectos el Cliente otorgará un mandato específico a Transbank y/o 
              cualquier otro documento que sea necesario y/o requerido por este último, 
              y deberá aceptar los términos y condiciones contenidos que se indica a continuación.
            </p>
          </div>
        </div>

        <div class="terms-section">
          <div class="section-header">
            <i class="fas fa-cog"></i>
            <h4>Mecanismo de Pago</h4>
          </div>
          <div class="section-body">
            <p>
              Para acceder esta forma de pago, el Cliente deberá ingresar al portal de
              clientes en la página web de La Inmobiliaria, y elegir dentro de las
              opciones para materializar el pago de su respectivo contrato y de acuerdo
              a lo convenido en él, el número de cuotas, el monto de ellas y la fecha de
              pago/cargo.
            </p>
            <p>
              Para tales efectos, deberá seleccionar la opción "Pagos",
              accediendo a la interfaz de ésta, mediante la cual, dependiendo de la
              opción que escoja, podrá a su vez optar por el pago mediante:
            </p>
            <ul class="payment-options-list">
              <li><i class="fas fa-university"></i> <strong>PAC</strong> - Pago automático en cuenta corriente</li>
              <li><i class="fas fa-credit-card"></i> <strong>PAT</strong> - Pago automático en tarjeta de crédito</li>
            </ul>
            <p>
              Canalizándose a través de Webpay Oneclick de Transbank y/o
              mediante otra u otras que podrían estar disponibles para los mismos
              efectos, caso en el cual se conectará a ellas, aplicando asimismo los
              términos y condiciones particulares de la correspondiente Webpay.
            </p>
          </div>
        </div>

        <div class="terms-section">
          <div class="section-header">
            <i class="fas fa-exclamation-triangle"></i>
            <h4>Condiciones Importantes</h4>
          </div>
          <div class="section-body">
            <div class="highlight-box">
              <p>
                <i class="fas fa-check-circle"></i>
                Cualquiera sea la opción de pago que escoja el Cliente mediante la
                plataforma Mi Cuenta - Pagos, deberá ingresar, completar, otorgar y/o
                suscribir todos los antecedentes, mandatos y/o demás información que al
                efecto se requiera.
              </p>
            </div>
            <p>
              Cualquiera que sea la modalidad elegida por el Cliente, deberá respetar la
              periodicidad, número de cuotas, monto y fecha de pago/cargo que se
              convenga en el respectivo contrato de promesa de compraventa o de
              compraventa que La Inmobiliaria y el Cliente suscriban.
            </p>
            <p>
              Cualquier transacción que se efectúe mediante el sistema referido, será
              canalizada y administrada a través de los sistemas y páginas web que
              Transbank disponga para ello. La web de La Inmobiliaria, solo permitirá
              redireccionar a cada Cliente a los referidos sistemas y páginas web, por
              lo que La Inmobiliaria no tendrá acceso ni guardará los datos ingresados
              por el Cliente, cualquiera que estos sean y especialmente respecto de la
              cuenta y/o tarjeta registradas por el Cliente al configurar la opción de
              pago.
            </p>
            <div class="warning-box">
              <i class="fas fa-info-circle"></i>
              <p>
                La Inmobiliaria no tendrá responsabilidad alguna ni podrá
                imputársele cualquier problema de permeabilidad y/o fallas que puedan
                experimentar los sistemas y/o las páginas web de Transbank, mediante la
                cual se materialice el pago, y/o que en virtud de ello, pueda experimentar
                la cuenta y/o tarjeta registradas.
              </p>
            </div>
            <p>
              El Cliente solo podrá tener activa <strong>1 (una)</strong> cuenta o tarjeta por cada
              contrato que suscriba, por lo que si el Cliente deseara
              reemplazar la cuenta o tarjeta que hubiere registrado y reemplazarla por
              otra que estuviere vigente, podrá hacerlo directamente a través de la web
              de La Inmobiliaria. Cualquier cambio que se realice respecto de la modalidad de
              pago deberá acordarse previamente entre La Inmobiliaria y el Cliente.
            </p>
          </div>
        </div>

        <div class="terms-section authorization-section">
          <div class="section-header">
            <i class="fas fa-check-double"></i>
            <h4>Autorización de Pago Automático</h4>
          </div>
          <div class="section-body">
            <p>
              Con la aceptación de los presentes términos y condiciones, independiente
              de los mandatos que al efecto deban otorgarse, y/o de los términos y
              condiciones propios de Transbank disponga al efecto, el Cliente autoriza
              por esta aceptación, <strong>expresamente a Transbank</strong> para que ésta concurra al
              Banco que corresponda, y le solicite los fondos que corresponda, con cargo
              a la Cuenta Corriente y/o a la Tarjeta de Crédito designada para tal
              efecto, y que con dichos fondos proceda directamente al pago de las cuotas
              comprometidas a pagar a La Inmobiliaria, destinando al pago del precio del
              contrato de promesa de compraventa respectivo, calculado en base al valor
              de la UF del día de pago acordado y/o efectivo.
            </p>
            <p>
              El pago, para el caso de Pago Automático con cargo a la Cuenta Corriente,
              se materializará mediante la transferencia directa a La Inmobiliaria. 
              <strong>La presente autorización tiene vigencia indefinida.</strong>
            </p>
            <div class="highlight-box revocation-box">
              <p>
                <i class="fas fa-undo"></i>
                <strong>Revocación:</strong> El Cliente podrá revocar esta autorización, siempre que en forma previa
                haya acordado con La Inmobiliaria la nueva modalidad de pago, de lo que deberá
                darse cuenta de ello mediante la celebración de la respectiva modificación
                del contrato de promesa de compraventa que se hubiere firmado.
              </p>
            </div>
            <p>
              La presente autorización se entenderá otorgada, para todos los efectos legales, el
              mismo día en que, a través de la web de La Inmobiliaria, se proceda a configurar
              la opción de pago a través de la opción Transbank, entregándose,
              otorgándose y/o suscribiéndose todos los antecedentes, mandatos y/o demás
              información que al efecto ésta requiera.
            </p>
            <p>
              Todas las autorizaciones que se hubieren otorgado en forma indefinida, se
              entenderán <strong>renovadas mes a mes</strong>, en tanto no se revoque por escrito.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer con logos -->
    <div class="terms-footer">
      <div class="footer-logos">
        <div class="logo-item">
          <i class="fas fa-lock"></i>
          <span>Conexión segura</span>
        </div>
        <div class="logo-item">
          <i class="fas fa-credit-card"></i>
          <span>Transbank</span>
        </div>
        <div class="logo-item">
          <i class="fas fa-shield-alt"></i>
          <span>Datos protegidos</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OneclickTerms",
  components: {},
  props: {
    legal_name: null,
    project_id: { default: null },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
  },
};
</script>

<style scoped>
.terms-container {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 5px;
}

.terms-container::-webkit-scrollbar {
  width: 6px;
}

.terms-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.terms-container::-webkit-scrollbar-thumb {
  background: var(--color-btn, #3b82f6);
  border-radius: 10px;
  opacity: 0.5;
}

.terms-container::-webkit-scrollbar-thumb:hover {
  background: var(--color-btn, #2563eb);
}

/* Header */
.terms-header {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 20px;
}

.terms-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, var(--color-btn, #3b82f6), #60a5fa);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.terms-icon i {
  color: white;
  font-size: 22px;
}

.terms-title-section {
  flex: 1;
}

.terms-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 4px 0;
}

.terms-subtitle {
  font-size: 0.9rem;
  color: #6b7280;
  margin: 0;
}

/* Security Badge */
.security-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  color: #059669;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 20px;
}

.security-badge i {
  font-size: 14px;
}

/* Terms Content */
.terms-content {
  text-align: justify;
}

/* Sections */
.terms-section {
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #e5e7eb;
}

.terms-section.authorization-section {
  background: linear-gradient(135deg, #fef3c7, #fef9c3);
  border-color: #fcd34d;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.authorization-section .section-header {
  border-color: #fcd34d;
}

.section-header i {
  width: 28px;
  height: 28px;
  background: var(--color-btn, #3b82f6);
  color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.authorization-section .section-header i {
  background: #f59e0b;
}

.section-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
}

.section-body {
  color: #4b5563;
  font-size: 0.9rem;
  line-height: 1.7;
}

.section-body p {
  margin: 0 0 12px 0;
}

.section-body p:last-child {
  margin-bottom: 0;
}

/* Payment Options List */
.payment-options-list {
  list-style: none;
  padding: 0;
  margin: 12px 0;
}

.payment-options-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 15px;
  background: white;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid #e5e7eb;
}

.payment-options-list li i {
  color: var(--color-btn, #3b82f6);
  font-size: 16px;
}

/* Highlight Box */
.highlight-box {
  background: white;
  border-left: 4px solid var(--color-btn, #3b82f6);
  padding: 15px;
  border-radius: 0 8px 8px 0;
  margin: 15px 0;
}

.highlight-box p {
  margin: 0 !important;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.highlight-box i {
  color: var(--color-btn, #3b82f6);
  margin-top: 3px;
  flex-shrink: 0;
}

.revocation-box {
  border-left-color: #f59e0b;
  background: rgba(255, 255, 255, 0.8);
}

.revocation-box i {
  color: #f59e0b;
}

/* Warning Box */
.warning-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fef3c7;
  padding: 15px;
  border-radius: 8px;
  margin: 15px 0;
}

.warning-box > i {
  color: #f59e0b;
  font-size: 18px;
  margin-top: 2px;
  flex-shrink: 0;
}

.warning-box p {
  margin: 0 !important;
  color: #92400e;
}

/* Footer */
.terms-footer {
  margin-top: 25px;
  padding-top: 20px;
  border-top: 2px solid #f0f0f0;
}

.footer-logos {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.logo-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  color: #9ca3af;
  font-size: 0.75rem;
}

.logo-item i {
  font-size: 20px;
  color: #6b7280;
}

/* Responsive */
@media (max-width: 576px) {
  .terms-header {
    flex-direction: column;
    text-align: center;
  }

  .terms-title {
    font-size: 1.1rem;
  }

  .terms-section {
    padding: 15px;
  }

  .section-header h4 {
    font-size: 0.95rem;
  }

  .section-body {
    font-size: 0.85rem;
  }

  .payment-options-list li {
    padding: 8px 12px;
    font-size: 0.85rem;
  }

  .footer-logos {
    gap: 20px;
  }

  .highlight-box,
  .warning-box {
    padding: 12px;
  }
}
</style>
